// Maps the spoton save endpoint's outcome (integration/setSpotOnBlid's
// { success, status, code, message } return) to the copy shown under the BLID
// field. Keyed on `code`, never on status alone — the endpoint uses two
// different 404s (not-recognized vs. the Lambda's own not-found guard) that
// mean opposite things to the operator.
const GENERIC_MESSAGE = "We couldn't confirm this ID with SpotOn. Please try again."

export function spotOnBlidErrorMessage(result, spotOnBlidInput) {
  const code = result?.code

  if (code === 'spoton/blid-not-recognized') {
    return `BLID ${spotOnBlidInput} was not found in SpotOn. Check the ID and try again. Nothing was saved.`
  }
  if (code === 'spoton/blid-in-use') {
    return 'That BLID is already associated with another location'
  }
  if (code === 'spoton/location-already-linked') {
    return 'This location is already linked to a different SpotOn BLID. Contact support to change it. Nothing was saved.'
  }
  if (code === 'forbidden' || code === 'not-found') {
    return "You don't have access to update this location."
  }
  if (code === 'validation-error' || code === 'scope-not-supported') {
    return 'Format is BL-XXXX-XXXX-XXXX.'
  }

  // status 0 / no body (authorizer 403 arriving as CORS), 502, timeout, and
  // every other unmapped failure. Never claims nothing was saved — a timeout
  // is ambiguous, and a retry is idempotent.
  return GENERIC_MESSAGE
}
